var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatmaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9641 17.5584C6.54991 18.9554 1.28149 16.9277 0.19675 13.0294C-0.887988 9.13116 2.62172 4.83854 8.03591 3.44157C13.4501 2.04461 18.7185 4.07232 19.8033 7.97058C20.888 11.8688 17.3783 16.1615 11.9641 17.5584Z",
    fill: "#D9D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0644 15.5221C10.0305 17.5825 6.434 17.7004 5.03142 15.7854C3.62885 13.8704 4.95134 10.6477 7.98528 8.58723C11.0192 6.5268 14.6157 6.40891 16.0183 8.32392C17.4209 10.2389 16.0984 13.4617 13.0644 15.5221Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1236 15.4482C9.48711 16.5596 7.60644 16.704 6.92297 15.7708C6.23949 14.8377 7.01203 13.1802 8.64848 12.0689C10.2849 10.9575 12.1656 10.8131 12.8491 11.7463C13.5325 12.6794 12.76 14.3369 11.1236 15.4482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmaps);
export default __webpack_public_path__ + "static/media/heatmaps.5693ac84365aab330e2df69ed23374c5.svg";
export { ForwardRef as ReactComponent };